"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useRef } from "react";
import Bg_Dots from "~/public/assets/backgrounds/bg-dots-2.png";
import BgFlowLeft from "~/public/assets/backgrounds/bg-flow-left.png";
import BgFlowRight from "~/public/assets/backgrounds/bg-flow-right.png";
import { NumbersFlowSection } from "../numbers-flow/numbers-flow-section";
import { useWhyFlowlabAnimation } from "./use-why-flowlab-animation";
type WhyFlowlabStat = {
  value: string;
  label: string;
  description: string;
};
export type WhyFlowlabSectionProps = {
  tag?: string;
  title?: string;
  description?: string;
  stats?: WhyFlowlabStat[];
  hasNumbers?: boolean;
};
export default function WhyFlowlabSection(t0) {
  const $ = _c(22);
  const {
    tag: t1,
    title: t2,
    description: t3,
    hasNumbers: t4
  } = t0;
  const tag = t1 === undefined ? "Por que a Flowlab" : t1;
  const title = t2 === undefined ? "Entregamos 2-3x mais r\xE1pido do que um time interno. Sem abrir m\xE3o da qualidade." : t2;
  const description = t3 === undefined ? "Somos um parceiro de produto, com processo pr\xF3prio, time especializado e 10 anos de aprendizado aplicado em cada projeto." : t3;
  const hasNumbers = t4 === undefined ? true : t4;
  const sectionRef = useRef(null);
  useWhyFlowlabAnimation(sectionRef);
  let t5;
  if ($[0] !== hasNumbers) {
    t5 = hasNumbers ? <><Image src={BgFlowLeft} alt="" aria-hidden="true" className="why-flowlab-bg hidden 2xl:block h-auto w-full max-w-[8%] 3xl:max-w-[9.7%] max-h-[70%] top-0 left-0 absolute" priority={false} width={1000} height={1000} /><Image src={BgFlowRight} alt="" aria-hidden="true" className="why-flowlab-bg hidden 2xl:block h-auto w-full max-w-[8.5%] 3xl:max-w-[9.7%] max-h-[70%] top-0 right-0 absolute" priority={false} width={1000} height={1000} /></> : <><Image src={Bg_Dots} alt={"Imagem de fundo de pontos para decora\xE7\xE3o"} aria-hidden="true" className="absolute left-0 bottom-0 w-full h-auto max-w-[8%] 3xl:max-w-[9.8%] hidden lg:block" /><Image src={Bg_Dots} alt={"Imagem de fundo de pontos para decora\xE7\xE3o"} aria-hidden="true" className="absolute right-0 bottom-0 w-full h-auto max-w-[8%] 3xl:max-w-[9.8%] hidden lg:block" /></>;
    $[0] = hasNumbers;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="hidden md:inline-flex absolute -top-1.75 -left-1.75 z-20 h-3 w-3 border border-gray-300 bg-gray-300" />;
    t7 = <span className="hidden md:inline-flex absolute -top-1.75 -right-1.75 z-20 h-3 w-3 border border-gray-300 bg-gray-300" />;
    $[2] = t6;
    $[3] = t7;
  } else {
    t6 = $[2];
    t7 = $[3];
  }
  let t8;
  if ($[4] !== tag) {
    t8 = <p className="tag why-flowlab-intro mb-6">{tag}</p>;
    $[4] = tag;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== title) {
    t9 = <h2 className="title why-flowlab-intro mx-auto whitespace-pre-line">{title}</h2>;
    $[6] = title;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== description) {
    t10 = <p className="description why-flowlab-intro mx-auto mt-8">{description}</p>;
    $[8] = description;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t10 || $[11] !== t8 || $[12] !== t9) {
    t11 = <div className="mx-auto max-w-178 text-center">{t8}{t9}{t10}</div>;
    $[10] = t10;
    $[11] = t8;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== hasNumbers) {
    t12 = hasNumbers && <div className="mt-24"><NumbersFlowSection /></div>;
    $[14] = hasNumbers;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t11 || $[17] !== t12) {
    t13 = <div className="container relative z-10 border-gray-300 py-20 md:border-x md:py-28 px-6 lg:px-18 3xl:px-24!">{t6}{t7}{t11}{t12}</div>;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13 || $[20] !== t5) {
    t14 = <section ref={sectionRef} className="md:container-padding relative border-t border-gray-300 text-white" id="why-flowlab">{t5}{t13}</section>;
    $[19] = t13;
    $[20] = t5;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  return t14;
}